import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

/**
 * Generated class for the SafeHtmlPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 *
 * Uses DomSanitizer.sanitize() instead of bypassSecurityTrustHtml() to avoid
 * triggering the angular#unsafe-bypass TrustedTypes policy, which lacks a
 * createHTML member in Safari 26+ (iOS 18.7+) and causes a TypeError.
 */
@Pipe({
  name: 'safeHtml',
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }
  transform(html: string | SafeHtml | null | undefined): SafeHtml | string {
    try {
      if (html == null || html === '' || html === undefined) {
        return '';
      }
      return this.sanitizer?.bypassSecurityTrustHtml(html as string);
    } catch (error) {
      return '';
    }
  }
}